/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Download_TemplateInputs */



/**
* | output |
* | --- |
* | "Download blank template" |
*
* @param {Archon_Download_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_download_template = /** @type {((inputs?: Archon_Download_TemplateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Download_TemplateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Télécharger le modèle vierge")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descargar plantilla en blanco")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Baixar modelo em branco")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scarica il modello vuoto")
	return /** @type {LocalizedString} */ ("Download blank template")
});